import * as Yup from 'yup';

const schema = Yup.object().shape({
  password: Yup.string().required('password.required').min(6, 'password.min6').max(40, 'password.max40'),
  repeat: Yup.string().oneOf([Yup.ref('password'), null], 'password.match')
});

export default schema;
